import { Collapse, Typography } from "antd";
import React from "react";
import ChestPhysiotherapy from "./ChestPhysiotherapy";
import RespiratorySupport from "./RespiratorySupport";
import Tracheostomy from "./Tracheostomy";

const RespiratoryCare = ({ data }) => {
  const respiratoryData = data?.data?.respiratory_care_respiratory_support;
  const tracheostomyData = data?.data?.respiratory_care_tracheostomy_care;
  const chestPhysioData = data?.data?.respiratory_care_chest_physiotherapy;

  const hasRespiratory = respiratoryData?.length > 0;
  const hasTracheostomy = tracheostomyData?.length > 0;
  const hasChestPhysio = chestPhysioData?.length > 0;

  if (!hasRespiratory && !hasTracheostomy && !hasChestPhysio) {
    return (
      <div style={{ textAlign: "center", padding: "24px 0", color: "#98A2B3" }}>
        <Typography.Text type="secondary">No respiratory care items</Typography.Text>
      </div>
    );
  }

  const defaultKeys = [];
  if (hasRespiratory) defaultKeys.push("1");
  if (hasTracheostomy) defaultKeys.push("2");
  if (hasChestPhysio) defaultKeys.push("3");

  return (
    <div>
      <Collapse
        expandIconPosition="end"
        className="custom-collapse"
        style={{ marginTop: "10px" }}
        defaultActiveKey={defaultKeys}
      >
        {hasRespiratory && (
          <Collapse.Panel header="Respiratory Support View" key="1">
            <RespiratorySupport data={respiratoryData} />
          </Collapse.Panel>
        )}
        {hasTracheostomy && (
          <Collapse.Panel header="Tracheostomy Care" key="2">
            <Tracheostomy data={tracheostomyData} />
          </Collapse.Panel>
        )}
        {hasChestPhysio && (
          <Collapse.Panel header="Chest Physiotherapy View" key="3">
            <ChestPhysiotherapy data={chestPhysioData} />
          </Collapse.Panel>
        )}
      </Collapse>
    </div>
  );
};

export default RespiratoryCare;
